import { SocialIcons } from '../../assets/icons';
import { config } from '../../config/config';
import { Socials as SocialsEnum } from '../../config/constants';
import ExternalLink from '../ExternalLink';

const Socials = () => (
    <div className='socials'>
        {Object.entries(config.socialMedias).map(([name, link]) => (
            <ExternalLink key={name} to={link}>
                {SocialIcons[name as SocialsEnum]}
            </ExternalLink>
        ))}
    </div>
);

export default Socials;
